class mDatePickerMenu extends HTMLDivElement {
    constructor() {
        super();
        this.currentStyle = window.getComputedStyle(this);
        this.lastMousedownWasOutside = false;

        this.addEventListener('keydown', this.onKeydown.bind(this));

        this.onMousedownDocument = this.onMousedownDocument.bind(this);
        this.onClickDocument = this.onClickDocument.bind(this);
    }

    connectedCallback() {
        document.addEventListener('mousedown', this.onMousedownDocument, { passive: true });
        document.addEventListener('click', this.onClickDocument, { passive: true });
    }

    disconnectedCallback() {
        document.removeEventListener('mousedown', this.onMousedownDocument);
        document.removeEventListener('click', this.onClickDocument);
    }

    onKeydown(event) {
        let stopEvent = false;
        let elems;

        switch (event.key) {
            case 'Escape':
                this.dispatchEvent(new Event('close'));
                stopEvent = true;
                break;

            case 'Tab':
                elems = this.querySelectorAll('button, a, textarea, input, select, [tabindex="0"]');
                if (elems.length > 0) {
                    if (event.shiftKey && document.activeElement === elems[0]) {
                        stopEvent = true;
                        elems[elems.length - 1].focus();
                    } else if (!event.shiftKey && document.activeElement === elems[elems.length - 1]) {
                        stopEvent = true;
                        elems[0].focus();
                    }
                }
                break;

            default:
                break;
        }

        if (stopEvent) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    checkMouseEventOutside(event) {
        if (this.currentStyle.getPropertyValue('display') === 'none') {
            return false;
        }
        return !this.contains(event.target);
    }

    onMousedownDocument(event) {
        this.lastMousedownWasOutside = this.checkMouseEventOutside(event);
    }

    onClickDocument(event) {
        if (this.lastMousedownWasOutside && this.checkMouseEventOutside(event)) {
            this.dispatchEvent(new Event('close'));
        }
    }
}

customElements.define('m-date-picker-menu', mDatePickerMenu, {
    extends: 'div'
});
